import { connect } from 'react-redux';
import {
  setActiveSupplierAuthTab,
  setDialogDetails,
  setMobileFilterDrawerOpen,
  setSupplierAuthorizationsPending,
} from './store/supplierAuthorizationSlice';
import { resetFilters } from '../filters/store/filtersSlice';
import SupplierAuthorizations from './SupplierAuthorizations';

const mapState = state => ({
  dialogDetails: state.loadingManagement.supplierAuthorizations.dialogDetails || {},
  supplierAuthorizationsError:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsError,
});

const mapDispatch = {
  resetFilters,
  setActiveSupplierAuthTab,
  setDialogDetails,
  setMobileFilterDrawerOpen,
  setSupplierAuthorizationsPending,
};

export default connect(mapState, mapDispatch)(SupplierAuthorizations);
